import { CHECKOUT_RT_SLICE_NAME, checkoutRTReducer } from './checkoutRT';

export const CHECKOUT_RT_STORE = {
  name: CHECKOUT_RT_SLICE_NAME,
  reducer: checkoutRTReducer,
};
